import React from 'react';

import { useTranslation } from 'react-i18next';

import { Avatar, type AvatarProps, AvatarSize } from '@pkg/components';
import { ReactComponent as IconImage } from '@pkg/components/Sections/Profile/icons/image.svg';

import { type EditableImageSize } from './types';

import { Action, EditableImageWrapper, Overlay, OverlayContent, OverlayIconWrapper, OverlayText } from './styles';

// TODO: Support `videoUrl` and pass with `autoPlay`.
export interface EditableImageProps extends Pick<AvatarProps, 'title' | 'imageUrl' | 'badge'> {
    size?: EditableImageSize;
    onAction(): void;
}

export function EditableImage({ imageUrl, title = '', badge, size = AvatarSize.Small, onAction }: EditableImageProps) {
    const { t: translate } = useTranslation('groups');

    const canRenderOverlayText = size === AvatarSize.Small || size === AvatarSize.Medium;

    const overlayMarkup = (
        <Overlay>
            <OverlayContent>
                <OverlayIconWrapper>
                    <IconImage />
                </OverlayIconWrapper>

                {canRenderOverlayText ? <OverlayText>{translate('pods_image_overlay')}</OverlayText> : null}
            </OverlayContent>
        </Overlay>
    );

    // Consider passing `disabled` when the `Avatar` is still `loading`.
    // The `onLoad` prop can be pulled from `AvatarProps`.
    return (
        <EditableImageWrapper $size={size}>
            <Action aria-label={translate('pods_image_a11y')} onClick={onAction}>
                <Avatar imageUrl={imageUrl} title={title} size={size} badge={badge}>
                    {overlayMarkup}
                </Avatar>
            </Action>
        </EditableImageWrapper>
    );
}
